import { render, staticRenderFns } from "./flowCustomerAct.vue?vue&type=template&id=e3815e16&scoped=true&"
import script from "./flowCustomerAct.vue?vue&type=script&lang=js&"
export * from "./flowCustomerAct.vue?vue&type=script&lang=js&"
import style0 from "./flowCustomerAct.vue?vue&type=style&index=0&id=e3815e16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3815e16",
  null
  
)

export default component.exports